import { useState } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import YachtCard from './components/YachtCard';
import FilterBar from './components/FilterBar';
import { yachtListings } from '../../mocks/yachtListings';

export default function YachtSales() {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [filteredYachts, setFilteredYachts] = useState(yachtListings);

  return (
    <div className="bg-white min-h-screen">
      <Navigation isVisible={isNavVisible} setIsVisible={setIsNavVisible} />
      
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/40053a131ea148410d77304e6cb0dce8.jpeg"
            alt="Luxury Superyachts"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>
        
        <div className="relative z-10 text-center px-8 max-w-4xl">
          <div className="w-20 h-px bg-white mx-auto mb-8"></div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight">
            Superyachts for Sale
          </h1>
          <p className="text-xl md:text-2xl text-white/90 leading-relaxed">
            Curated selection of the world's finest superyachts over $20 million
          </p>
        </div>
      </section>

      {/* Filter Bar */}
      <FilterBar yachts={yachtListings} onFilter={setFilteredYachts} />

      {/* Yacht Listings */}
      <section className="py-20 px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="text-lg text-gray-600">
              Showing {filteredYachts.length} superyacht{filteredYachts.length !== 1 ? 's' : ''}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {filteredYachts.map((yacht) => (
              <YachtCard key={yacht.id} yacht={yacht} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
